/**
 * Coupon Wallet Module - Nova
 *
 * Domain module for coupon wallet functionality.
 * Feature parity with mobile app coupon wallet.
 */

// Shared components
export { CouponWidget } from './components/coupon-widget';
export { CouponCard } from './components/coupon-card';
export { CouponDetailModal } from './components/coupon-detail-modal';
export { CouponSelectionScreen } from './components/coupon-selection-screen';

// Types
export type { CouponWidgetProps } from './components/coupon-widget/coupon-widget.types';
export type { CouponCardProps } from './components/coupon-card/coupon-card.types';
export type { CouponDetailModalProps } from './components/coupon-detail-modal/coupon-detail-modal.types';
export type { CouponSelectionScreenProps } from './components/coupon-selection-screen/coupon-selection-screen.types';
